<template>
  <div class="carousel-wrapper">
    <swiper :ref="reference" :options="options">
      <swiper-slide v-for="photo in photos" :key="photo.id">
        <img :src="photo.high" class="img-fluid" alt="">
        <!-- <bg-image :src="photo.thumb" :placeholder="photo.low">
          <div class="ar-75"></div>
        </bg-image> -->
      </swiper-slide>
    </swiper>

    <div class="navigation">
      <button type="button" class="button-prev" @click="prevSlide">
        <i class="icon-arrow-left"></i>
      </button>
      <button type="button" class="button-next" @click="nextSlide">
        <i class="icon-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'


  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    props: {
      reference: {
        type: String,
        required: false,
        default: null
      },
      photos: {
        type: Array,
        required: true,
        default: []
      }
    },
    data() {
      return {
        options: {
          slidesPerView: 1.5,
          spaceBetween: 10,
          centeredSlides: true,
          loop: true,
          breakpoints: {
            576: {
              slidesPerView: 2.5,
            },
          }
        }
      }
    },
    methods: {
      nextSlide() {
        this.$refs[this.reference].$swiper.slideNext()
      },
      prevSlide() {
        this.$refs[this.reference].$swiper.slidePrev()
      },
    },
  }
</script>

<style scoped lang="scss">
  .carousel-wrapper {
    position: relative;

    .swiper-slide {
      opacity: 0.2;
      transition: all 250ms ease-in-out;

      &.swiper-slide-active {
        opacity: 1;
      }
    }

    .navigation {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      z-index: 1;

      button {
        position: absolute;

        i {
          &::before {
            color: #61171b;
            font-size: 1.5rem;
          }
        }

        &.button-prev {
          left: 20%;
        }

        &.button-next {
          right: 20%;
        }
      }
    }
  }
</style>